import React from "react";
import "./testimonials.css";
import Avt1 from "../../assets/tomer.jpg";
import Avt2 from "../../assets/ilia.jpg";
import Avt3 from "../../assets/ron.jpg";
import Avt4 from "../../assets/rok.jpg";

import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    avatar: Avt1,
    name: "תומר יחזקאלי",
    review:
      "חיפשתי הרבה זמן מפתח תוכנה שיעזור לי למכור מוצרים שאני מכין, מתי שם דגש על כל פרט קטן אם זה עיצוב או מהירות של פיצרים. מממליץ בחום   ",
  },
  {
    avatar: Avt2,
    name: " איליה שווילי",
    review:
      "וואו וואו וואו זה מה שיש לי לומר. אני מייבא ממוצרים מחול והרבה זמן העסק לא זז, מתי בנה לי אתר מושלם וגם קישר לי אנשים מהתחום שלי ומאז העסק רץ, אין לי ספק שבגלל העיצוב והנגישות שמתי משקיע באתרים שהוא בונה",
  },
  {
    avatar: Avt3,
    name: " רון אסטרין",
    review:
      "יש לי עסק פרטי של מכירת מוצרים בעיצוב אישי, אני נאוד ממליץ על מתי, שאת חווית שירות מספר אחת. כולל פגישות פרונטאליות וייעוץ כל שעות היממה ללא לחץ. ממליץ מאוד",
  },
  {
    avatar: Avt4,
    name: " יעקב רוק",
    review:
      "אני מדריך כושר פרטי, מתי בנה לי אתר נוח ומיוחד שכולם מאוד מתלהבים ממנו ותמיד מחמיאים לי עליו, האתר אף פעם לא נתקע אבל מה שבטוח זה שהוא מביא לי לקוחות",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>לקוחות ממליצים</h5>
      <h2>המלצות</h2>

      <Swiper
        className="container testimonials__container"
        // install Swiper modules
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img className="name" src={avatar} alt="Avatar One" />
              </div>

              <h5 className="client__name"> {name} </h5>
              <small className="client__review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
